<app-header class="fixed-header" (toggleCollapsed)="toggleCollapsed()"
  (toggleMobileNav)="sidenav.toggle()"></app-header>
<mat-sidenav-container class="mainWrapper blue_theme light-theme" autosize autoFocus dir="ltr">
  <mat-sidenav style="background-color: rgb(255, 255, 255); border-radius: 0%;" #leftsidenav
    [mode]="isOver ? 'over' : 'side'" [opened]="!isOver" (openedChange)="onSidenavOpenedChange($event)"
    (closedStart)="onSidenavClosedStart()" class="sidebarNav fixed-sidenav">
    <app-sidebar [sidenav]="leftsidenav"></app-sidebar>
  </mat-sidenav>

  <mat-sidenav-content class="contentWrapper scrollable-content">
    <main class="pageWrapper maxWidth">
      <div>
        <!-- <app-breadcrumbs></app-breadcrumbs> -->

        <router-outlet></router-outlet>
      </div>
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>